var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompassIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: -1,
    width: 50,
    height: 50,
    rx: 12,
    fill: "#385CC7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9473 27.8975C12.4241 27.8975 12 27.4734 12 26.9502C12 26.427 12.4241 26.0029 12.9473 26.0029H35.0525C35.5757 26.0029 35.9998 26.427 35.9998 26.9502C35.9998 27.4734 35.5757 27.8975 35.0525 27.8975H12.9473Z",
    fill: "#385CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0032 22.8414C21.5617 22.8414 19.5825 20.8622 19.5825 18.4207C19.5825 15.9792 21.5617 14 24.0032 14C26.4447 14 28.4239 15.9792 28.4239 18.4207C28.4239 20.8622 26.4447 22.8414 24.0032 22.8414Z",
    fill: "#385CC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0031 19.0521C24.3519 19.0521 24.6346 18.7694 24.6346 18.4206C24.6346 18.0718 24.3519 17.7891 24.0031 17.7891C23.6543 17.7891 23.3716 18.0718 23.3716 18.4206C23.3716 18.7694 23.6543 19.0521 24.0031 19.0521Z",
    fill: "#385CC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4761 23.5146C19.8723 26.4335 15.3278 34.7536 15.1141 35.1439C14.9443 35.4542 14.5527 35.5645 14.2458 35.3884C12.101 34.1574 11.3655 31.4287 12.6015 29.3006L18.3622 19.1411C18.6052 21.0634 19.8084 22.6864 21.4761 23.5146Z",
    fill: "#2E3E5C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6399 19.1362L35.3988 29.2959C36.6363 31.4292 35.9019 34.1572 33.7598 35.3881C33.4527 35.5646 33.0605 35.454 32.8908 35.1431C29.0252 28.0604 27.3135 24.9275 26.5315 23.5114C28.1973 22.6816 29.3985 21.0582 29.6399 19.1362V19.1362Z",
    fill: "#2E3E5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassIcon);
export default __webpack_public_path__ + "static/media/compassIcon.2addaa8053fed50e8a4291d3e7889a64.svg";
export { ForwardRef as ReactComponent };